import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Router } from '@angular/router';
import { LoaderService } from '../../loader/loader.service';
import { Subscription } from 'rxjs';
import { HubConnection } from 'src/app/applicationModules/chat/service/chatHubService.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  Users: string = 'User';
  Permission: string = 'Permission';
  Roles: string = 'Roles';
  Organization: string = 'Organization';
  Module: string = 'Module';

  opensidebar: boolean = false;
  permissions: any[] = [];
  showUser: boolean = false;
  showPermission: boolean = false;
  showRole: boolean = false;
  showOrganization: boolean = false;
  pageName: any;
  showModuleMaster: boolean = false;
  currentUser: any;
  rolesarray: any[] = [];
  superAdminFlag: boolean = false;
  inputindex: any;
  submenu: boolean = false;
  activeLink: any;
  showDashboard: boolean = false;
  showCore: boolean = false;
  showContact: boolean = false;
  showCompany: boolean = false;
  showFileManager: boolean = false;
  showTask: boolean = false;
  showCalender: boolean = false;
  showChat: boolean = false;
  showForms: boolean = false;
  showProcessIntelligence: boolean = false;

  showAdminModule: boolean = false;
  showSettingModule: boolean = false;

  permissionAsssign: any[] = [];
  folderListPermission: any[] = [];
  folderList: any[] = [];
  navigation: any[] = [];

  rolesAsssign: any[] = [];
  rolesShow: boolean = false;
  superAdmin: boolean = false;
  clickEventsubscription: Subscription;
  menuModulesList: any[] = [];
  activeLinkName: any;
  adminSettingMenuList: any[] = [];
  newChatSubscriptionToShowCount: Subscription;
  ChatCount: number = 0;
  NewChatUserCount: any[] = [];
  clickEventRefreshMenusubscription: Subscription;
  databaseId: any;
  organizationId: string;
  OfficeIDList: any = [];
  myOfficeID: any;

  constructor(private constant: Constants, private ChatsignalRconnaction: HubConnection, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private _dataSharingService: DataSharingService,
    private router: Router, private loaderService: LoaderService,private statusConstant: StatusConstant,
    private formsService: FormsService,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
        const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
        this.databaseId = sessionStorage.getItem('databaseId')?? '';
        this.organizationId = sessionStorage.getItem('organizationID')?? '';
        this.currentUser = jwt_decode(token);
        var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
        offices.forEach((oe:any) => {
          this.OfficeIDList.push(oe.officeID)
          if (oe.isMyoffice == true)
            this.myOfficeID = oe.officeID;
        });
  }

  ngOnDestroy() {
    this.clickEventsubscription.unsubscribe();
  }

  // The menu comes only from the role modules returned by ValidateToken (modules with view
  // permission). menuModules is not used; no role modules means an empty menu.
  getRoleMenuModules(): any[] {
    let roleModules: any[] = [];
    try {
      roleModules = JSON.parse(sessionStorage.getItem('roleModules') ?? '[]');
    } catch {
      roleModules = [];
    }
    if (!Array.isArray(roleModules)) {
      return [];
    }
    // Top-level modules only: child modules are not shown in the sidebar
    return roleModules
      .filter((rm: any) => rm.canView == true && !(rm.parentID > 0))
      .map((rm: any) => ({ ...rm, child: null }));
  }

  ngAfterViewInit() {
    // this.ChatsignalRconnaction.createHubConnection();
    // this.newChatSubscriptionToShowCount = this.ChatsignalRconnaction.newChatRecived.subscribe(data => {
    //   if (data.toUsers.includes(this.currentUser.UID) && data.fromUser.userId !== this.currentUser.UID) {
    //     if (!this.NewChatUserCount.includes(data.fromUser.userId)) {
    //       this.NewChatUserCount.push(data.fromUser.userId);
    //       this.ChatCount = this.NewChatUserCount.length;
    //     }
    //   }
    // });

  }

  ngOnInit(): void {
    // this.clickEventsubscription = this._dataSharingService.getNewChatMessageCountUpdate().subscribe((result) => {
    //   if (result) {
    //     this.ChatCount = 0;
    //     this.NewChatUserCount = [];
    //   }
    // });
    this.clickEventRefreshMenusubscription = this._dataSharingService.getRequestMenu().subscribe((result) => {
      if (result == true) {
        this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles")?? '[]');
        let menuModulesList = this.getRoleMenuModules();
        this.menuModulesList = menuModulesList.filter((x:any) => x.mainModuleName != 'Admin' && x.mainModuleName != 'Settings');
        this.menuModulesList = this.menuModulesList.filter((x:any) => x.mainModuleName != "Chat");
        this.adminSettingMenuList = menuModulesList.filter((x:any) => x.mainModuleName == 'Admin' || x.mainModuleName == 'Settings');

        var emails = sessionStorage.getItem("email");
        var officeName = sessionStorage.getItem("officeName");
        // if(((emails=="mcalpin@live.com" && officeName=="Admissions") || emails=="paul@flowtrics.com" || emails=="shawn@flowtrics.com" || emails=="mohit@flowtrics.com" || emails=="jkemp@flowtrics.com" || emails=="jenny@mailinator.com")
        //    && !this.hasMenuModule("AI Document Generator")){
        //   //  this.menuModulesList.push({
        //   //     children: [],
        //   //     folderID: 0,
        //   //     icon: "medical_services",
        //   //     isAssign: true,
        //   //     mainModuleID: 40,
        //   //     mainModuleName: "AI Document Generator",
        //   //     orgModuleName: "AI Document Generator",
        //   //     parentID: 0,
        //   //     position: 40
        //   //   });

        //     //  this.menuModulesList.push({
        //     //   children: [],
        //     //   folderID: 0,
        //     //   icon: "assignment_ind",
        //     //   isAssign: true,
        //     //   mainModuleID: 40,
        //     //   mainModuleName: "Referral Management",
        //     //   orgModuleName: "Referral Management",
        //     //   parentID: 0,
        //     //   position: 41
        //     // });
        //  }

        // if (!this.menuModulesList.some((x: any) => x.mainModuleName === "Insurance Verification")) {
        //   const aiCostIdx = this.menuModulesList.findIndex((x: any) => x.mainModuleName === "AI Cost Tracking");
        //   const ivEntry = {
        //     children: [],
        //     folderID: 0,
        //     icon: "verified_user",
        //     isAssign: true,
        //     mainModuleID: 41,
        //     mainModuleName: "Insurance Verification",
        //     orgModuleName: "Insurance Verification",
        //     parentID: 0,
        //     position: aiCostIdx >= 0 ? (this.menuModulesList[aiCostIdx].position ?? 0) + 1 : 99
        //   };
        //   if (aiCostIdx >= 0) {
        //     this.menuModulesList.splice(aiCostIdx + 1, 0, ivEntry);
        //   } else {
        //     this.menuModulesList.push(ivEntry);
        //   }
        // }

       // this.menuModulesList = this.uniqueModules(this.menuModulesList);

        // if (this.rolesAsssign != null) {
        //   if (this.rolesAsssign?.length > 0) {
        //     var role = [];
        //     // roleLevel:1 (Super admin), roleLevel:2 (Organization Admin), roleLevel:3 (Office Admin),
        //     // roleLevel:11 (User)
        //     role = this.rolesAsssign.filter((m) => m.roleLevel < 4);
        //     if (role.length == 0) {
        //       // this.adminSettingMenuList = this.adminSettingMenuList.filter((x:any) => x.mainModuleName != 'Admin' && x.mainModuleName != 'Settings');
        //       this.adminSettingMenuList = this.adminSettingMenuList.filter((x:any) => x.mainModuleName != 'Admin');
        //     }
        //   }
        // }
      }
    });

    this.navigation = [];
    //this.permissionAsssign = JSON.parse(sessionStorage.getItem("permissions"));    
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles")?? '[]');
    var menuModulesList = this.getRoleMenuModules();
    this.menuModulesList = menuModulesList.filter((x:any) => x.mainModuleName != 'Admin' && x.mainModuleName != 'Settings');
    this.menuModulesList = this.menuModulesList.filter((x:any) => x.mainModuleName != "Chat");
    this.adminSettingMenuList = menuModulesList.filter((x:any) => x.mainModuleName == 'Admin' || x.mainModuleName == 'Settings');

    var emails = sessionStorage.getItem("email");
    var officeName = sessionStorage.getItem("officeName");
    // if(((emails=="mcalpin@live.com" && officeName=="Admissions") || emails=="paul@flowtrics.com" || emails=="shawn@flowtrics.com" || emails=="mohit@flowtrics.com" || emails=="jkemp@flowtrics.com" || emails=="jenny@mailinator.com")
    //    && !this.hasMenuModule("AI Document Generator")){
    // this.menuModulesList.push({
    //   children: [],
    //   folderID: 0,
    //   icon: "medical_services",
    //   isAssign: true,
    //   mainModuleID: 40,
    //   mainModuleName: "AI Document Generator",
    //   orgModuleName: "AI Document Generator",
    //   parentID: 0,
    //   position: 21
    // });
    //  this.menuModulesList.push({
    //           children: [],
    //           folderID: 0,
    //           icon: "assignment_ind",
    //           isAssign: true,
    //           mainModuleID: 40,
    //           mainModuleName: "Referral Management",
    //           orgModuleName: "Referral Management",
    //           parentID: 0,
    //           position: 22
    //         });
    //}

    // if (!this.menuModulesList.some((x: any) => x.mainModuleName === "Insurance Verification")) {
    //   const aiCostIdx = this.menuModulesList.findIndex((x: any) => x.mainModuleName === "AI Cost Tracking");
    //   const ivEntry = {
    //     children: [],
    //     folderID: 0,
    //     icon: "verified_user",
    //     isAssign: true,
    //     mainModuleID: 41,
    //     mainModuleName: "Insurance Verification",
    //     orgModuleName: "Insurance Verification",
    //     parentID: 0,
    //     position: aiCostIdx >= 0 ? (this.menuModulesList[aiCostIdx].position ?? 0) + 1 : 99
    //   };
    //   if (aiCostIdx >= 0) {
    //     this.menuModulesList.splice(aiCostIdx + 1, 0, ivEntry);
    //   } else {
    //     this.menuModulesList.push(ivEntry);
    //   }
    // }

   // this.menuModulesList = this.uniqueModules(this.menuModulesList);

    // if (this.rolesAsssign != null) {
    //   if (this.rolesAsssign?.length > 0) {
    //     var role = [];
    //     // roleLevel:1 (Super admin), roleLevel:2 (Organization Admin), roleLevel:3 (Office Admin),
    //     // roleLevel:11 (User)
    //     role = this.rolesAsssign.filter((m) => m.roleLevel < 4);
    //     if (role.length == 0) {
    //       // this.adminSettingMenuList = this.adminSettingMenuList.filter((x:any) => x.mainModuleName != 'Admin' && x.mainModuleName != 'Settings');
    //       this.adminSettingMenuList = this.adminSettingMenuList.filter((x:any) => x.mainModuleName != 'Admin');
    //     }
    //   }
    // }

    this.clickEventsubscription = this._dataSharingService.getShowFormsSiderbar().subscribe((result) => {
      if (result) {
        this.activeLinkName = result;//"Forms";
      }
    });

    //this.activeLinkName="Dashboard";
    //   if(this.rolesAsssign !=null){
    //     if(this.rolesAsssign?.length > 0){
    //       var role=[];
    //       role= this.rolesAsssign.filter((m) => m.roleLevel == 2 || m.roleLevel == 1);
    //       if(role.length > 0){
    //         this.rolesShow=true;
    //         var checkSuperAdmin=[];
    //          checkSuperAdmin = role.filter((m) => m.roleLevel == 1);
    //           if(checkSuperAdmin.length > 0){
    //             this.superAdmin=true;         
    //           } else{
    //             this.superAdmin=false;
    //           }    
    //        }
    //      }
    //   }

    //   if(this.permissionAsssign !=null){
    //   if(this.permissionAsssign?.length > 0){
    //     for (var i = 0, len = this.permissionAsssign.length; i < len; ++i) {
    //       var menu = this.permissionAsssign[i].permissionName;
    //       this.showDashboard = true;    
    //       if(menu == "Menu Core" || this.superAdmin==true){
    //         this.showCore =true;       
    //       }
    //       if(menu == "Menu Contact" || this.superAdmin==true){
    //         this.showContact =true;         
    //       }  
    //       if(menu == "Menu Company" || this.superAdmin==true){
    //         this.showCompany =true;         
    //       }
    //       if(menu == "Menu Task" || this.superAdmin==true){
    //         this.showTask=true;         
    //       }
    //       if(menu == "Menu File Manager" || this.superAdmin==true){
    //         this.showFileManager=true;          
    //       } 
    //       if(menu == "Menu Calender" || this.superAdmin==true){
    //         this.showCalender=true;         
    //       } 
    //       if(menu == "Menu Chat" || this.superAdmin==true){
    //         this.showChat=true;          
    //       } 
    //       if(menu == "Menu Forms" || this.superAdmin==true){
    //         this.showForms=true;         
    //       } 
    //       if(menu == "Menu Process Intelligence" || this.superAdmin==true){
    //         this.showProcessIntelligence=true;         
    //       } 
    //       if((menu == "Admin Module Permission" || this.superAdmin==true) && this.rolesShow == true){         
    //           this.showAdminModule =true;
    //       }  
    //       // if(menu == "User" && this.rolesShow == true){
    //       //   this.showAdminModule =true;
    //       // }
    //       // if(menu == "Permission" && this.rolesShow == true){
    //       //   this.showAdminModule =true;
    //       // }
    //       // if(menu == "Role" && this.rolesShow == true){
    //       //   this.showAdminModule =true;
    //       // }
    //       // if(menu == "Organization" && this.rolesShow == true){
    //       //   this.showAdminModule =true;
    //       // }
    //       // if(menu == "Module" && this.rolesShow == true){
    //       //   this.showAdminModule =true;
    //       // }
    //       if((menu == "Settings Module Permission" || this.superAdmin==true) && this.rolesShow == true){
    //         this.showSettingModule =true;       
    //       }
    //    } 
    //   }  
    //  }  


  }



  // Display names for the sidebar only, keyed by mainModuleName. Routing, the
  // active-link match and the page headers keep using the server's names.
  private readonly sidebarLabels: { [mainModuleName: string]: string } = {};

  sidebarLabel(link: any): string {
    return this.sidebarLabels[link?.mainModuleName] || link?.orgModuleName;
  }

  // The server's menu may already carry modules this component also adds itself
  // (AI Document Generator, AI Cost Tracking); check before adding a second copy.
  hasMenuModule(mainModuleName: string): boolean {
    return (this.menuModulesList || []).some((x: any) => x.mainModuleName === mainModuleName);
  }

  // one sidebar entry per module (first one wins)
  private uniqueModules(list: any[]): any[] {
    return (list || []).filter((x: any, i: number, all: any[]) =>
      all.findIndex((y: any) => y.mainModuleName === x.mainModuleName) === i);
  }

  linkclick(link:any) {
    sessionStorage.removeItem("ntaSummaryJson");
    sessionStorage.removeItem("FillPlaceholderDoc");
    sessionStorage.removeItem("currentCoreTabIndex");
    sessionStorage.removeItem('QueryParam');
    
    this.getThirdPartyApplicationList();
    if (link.mainModuleName == 'Chat') {
      this.ChatCount = 0;
      this.NewChatUserCount = [];
    }
    sessionStorage.setItem('HeaderModuleName', link.orgModuleName);
    sessionStorage.setItem('mainModuleNames', link.mainModuleName);
    this._dataSharingService.sendSelectedModuleName(link.orgModuleName);
    this.activeLink = link.mainModuleName;
    this.activeLinkName = link.orgModuleName;
    sessionStorage.removeItem("edashboard");     
    if (link.mainModuleName == "Dashboard") {
      // sessionStorage.setItem('DashboardRefresh', "true"); 
      this.router.navigate(['/dashboard']);
    }
    if (link.mainModuleName == "Core") {
      var showList = sessionStorage.getItem('coreshowListing');
      if (showList == 'true') {
        this.router.navigate(['/core/listing']);
        return;
      }

      var showkanban = sessionStorage.getItem('coreshowkanban');
      if (showkanban == 'true') {
        this.router.navigate(['/core/kanbanview'], {});
        return;
      }

      var showGrouping = sessionStorage.getItem('coreshowGrouping');
      if (showGrouping == 'true') {
        sessionStorage.setItem("gridViewModuleName", "Core");
        this._dataSharingService.sendGroupingList3C();
        this.router.navigate(['gridView']);
        return;
      } else {
        this.router.navigate(['/core/listing']);
      }
    }
    if (link.mainModuleName == "Contact") {
      var showList = sessionStorage.getItem('contactshowListing');
      if (showList == 'true') {
        this.router.navigate(['/contact/listing']);
        return;
      }
      var showkanban = sessionStorage.getItem('contactshowkanban');
      if (showkanban == 'true') {
        this.router.navigate(['/contact/kanbanview'], {});
        return;
      }
      var showGrouping = sessionStorage.getItem('contactshowGrouping');
      if (showGrouping == 'true') {
        sessionStorage.setItem("gridViewModuleName", "Contact");
        this._dataSharingService.sendGroupingList3C();
        this.router.navigate(['gridView']);
        return;
      } else {
        this.router.navigate(['/contact/listing']);
      }
    }
    if (link.mainModuleName == "Company") {
      var showList = sessionStorage.getItem('companyshowListing');
      if (showList == 'true') {
        this.router.navigate(['/company/listing']);
        return;
      }
      var showkanban = sessionStorage.getItem('companyshowkanban');
      if (showkanban == 'true') {
        this.router.navigate(['/company/kanbanview'], {});
        return;
      }
      var showGrouping = sessionStorage.getItem('companyshowGrouping');
      if (showGrouping == 'true') {
        sessionStorage.setItem("gridViewModuleName", "Company");
        this._dataSharingService.sendGroupingList3C();
        this.router.navigate(['gridView']);
        return;
      } else {
        this.router.navigate(['/company/listing']);
      }
    }
    if (link.mainModuleName == "Forms") {
      sessionStorage.setItem('esignatureMenuActive', 'true');
      sessionStorage.setItem('esignatureMenuSharedActive', 'false');
      sessionStorage.setItem('isSharedWithMeForm', 'false');
      sessionStorage.setItem('MasterTemplatePDFForm', 'false');
      sessionStorage.setItem('MasterTemplateTabularForm', 'false');
      sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
      sessionStorage.setItem('MasterTemplateWebForm', 'false');
      this.router.navigate(['/esignature']);
      this._dataSharingService.SendCurrentFormContact(null);
      this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
    }
    if (link.mainModuleName == "File Manager") {
      sessionStorage.setItem('FileManagerMenuActive', 'true');
      sessionStorage.setItem('FileManagerMenuSharedActive', 'false');
      sessionStorage.setItem('isSharedWithMeFileManager', 'false');
      this.router.navigate(['/filemanager']);
      this._dataSharingService.SendCurrentFormContactFileManager(null);
      this._dataSharingService.sendSelectedFolderContentFromLeftMenuFileManager(null);
      this._dataSharingService.sendRefreshListForFileManagerAddFolder(0);
      this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
      this._dataSharingService.sendSelectedDocForGoogleDrive(null);
    }
    // if (link.mainModuleName == "Chat") {
    //   this._dataSharingService.sendAddAttachmentFile(null);
    //   this._dataSharingService.sendMessageUserOrGroup(null);
    //   this._dataSharingService.sendSelectedChatParticipant(null);
    //   this._dataSharingService.sendDeleteChatGroup(null);

    //   this.router.navigate(['/chat']);
    // }
    if (link.mainModuleName == "Task" || link.mainModuleName == "New Task") {
      this.router.navigate(['/task']);
    }
    if (link.mainModuleName == "Calendar" || link.mainModuleName == "Doctor") {
      this.router.navigate(['/calendar']);
    }
    if (link.mainModuleName == "Facility") {
      this.router.navigate(['/facility']);
    }
    if (link.mainModuleName == "Process Intelligence") {
      this.router.navigate(['/intelligence']);
    }
    if (link.mainModuleName == "Admin") {
      this.router.navigate(['/admin']);
    }
    if (link.mainModuleName == "Settings") {
      var role = [];
      role = this.rolesAsssign.filter((m) => m.roleLevel < 4);
      if (role.length == 0) {
        this.router.navigate(['settings/managetemplates']);
      } else {
        this.router.navigate(['/settings']);
      }
    }
    if (link.mainModuleName == "Reports") {
      this.router.navigate(['/reports']);
    }
    if (link.mainModuleName == "Workflow") {
      this.router.navigate(['/workflow']);
    }

    if (link.mainModuleName == "Resident Dashboard") {
      this.router.navigate(['/residentdashboard']);
    }

    if (link.mainModuleName == "Residents") {
      this.router.navigate(['/residentview']);
    }

    if (link.mainModuleName === "SNF Dashboard") {
      this.router.navigate(['/dashboard/health']);
    }
    

    if (link.mainModuleName === "SNF Reporting") {
      this.router.navigate(['/sfnReporting']);
    }

     if (link.mainModuleName === "Referral Management") {
      this.router.navigate(['/referralManagement']);
    }

    if (link.mainModuleName === "PDPM Dashboard") {
      this.router.navigate(['/dashboard/pdpm']);
    }
    if (link.mainModuleName === "Medicaid Approval") {
      this.router.navigate(['/medicareapproval']);
    }

    if (link.mainModuleName === "AI Document Generator") {
      this.router.navigate(['/aiDocuments']);
    }

    if (link.mainModuleName === "AI Cost Tracking") {
      this.router.navigate(['/aiCostTracking']);
    }

    if (link.mainModuleName === "Insurance Verification") {
      this.router.navigate(['/insuranceVerification']);
    }

    sessionStorage.setItem('HeaderModuleName', link.orgModuleName);
    this._dataSharingService.sendSelectedModuleName(link.orgModuleName);
    this.closeSidebar();
  }


   thirdPartyApplicationList: any = [] = [];
   responseHolder: any;

   getThirdPartyApplicationList() {   
    var ReqModel = {
      isOffice: true,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.formsService.getThirdPartyApis(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.thirdPartyApplicationList = this.responseHolder.data;
          if (this.thirdPartyApplicationList.length > 0) {
            var Paycheck = [];
            var PointClickCare = [];

            Paycheck = this.thirdPartyApplicationList.filter((x:any) => x.thirdPartyApiName.toLowerCase() == "Paychex".toLowerCase());
            PointClickCare = this.thirdPartyApplicationList.filter((x:any) => x.thirdPartyApiName.toLowerCase() == "PointClickCare".toLowerCase());

            if (Paycheck.length > 0) {
              if (Paycheck[0].apiAuthDetail != null) {
                if (Paycheck[0].apiAuthDetail.isRequestclientAccessed == true) {
                  sessionStorage.setItem('Paycheck', 'true');
                }
              }
            }
            if (PointClickCare.length > 0) {
              if (PointClickCare[0].apiAuthDetail != null) {
                if (PointClickCare[0].apiAuthDetail.isRequestclientAccessed == true) {
                  sessionStorage.setItem('PointClickCare', 'true');
                }
              }
            }
          }
        }
        else {
          this.thirdPartyApplicationList = [];
        }
      }
      else {
        this.thirdPartyApplicationList = [];
      }
    });
  }

  openSidebar() {
    document.body.classList.add('openmenu');
    this.opensidebar = true;
  }

  closeSidebar() {
    document.body.classList.remove('openmenu');
    this.opensidebar = false;
  }


  // openSubMenu(linkName) {
  //   if(linkName == "Admin" || linkName == "Settings"){
  //     sessionStorage.setItem('HeaderModuleName', linkName);   
  //     this._dataSharingService.sendSelectedModuleName(linkName);
  //   }   
  //   if (linkName == "Admin") {
  //     this.submenu = !this.submenu;
  //     if (this.submenu == true) {
  //       this.pageName = linkName;
  //     }
  //     else {
  //       this.pageName = '';
  //     }
  //   }
  // }


  // navigationbottom = [
  //   {
  //     pageicon: 'supervised_user_circle',
  //     pagename: 'Admin',     
  //     routerLink: 'admin'      
  //   },
  //   {
  //     pageicon: 'settings',
  //     pagename: 'Settings',
  //     submenu: 'keyboard_arrow_down',
  //     routerLink:'/settings'  
  //   }

  // ]

}

